export default "__VITE_ASSET__aff451cf__"